import { Box, BoxProps, Button, Card, CardProps, Typography } from "@mui/material";
import { ReactElement } from "react";

import styles from "./friendRequest.module.scss";

export interface FriendRequestProps {
  avatar: ReactElement;
  name: string;
  type: "sent" | "received";
  onAccept?: () => void;
  onCancel: () => void;
}

function CardAsBox(props: CardProps & BoxProps): JSX.Element {
  return <Card {...props} />;
}

export default function FriendRequest(props: FriendRequestProps): JSX.Element {
  const { avatar, name, type, onAccept, onCancel } = props;

  return (
    <CardAsBox component={Box} px={2} pt={3} pb={1} my={1}>
      <Box display='flex' alignItems='center'>
        {avatar}
        <Typography ml={3} variant='body2' color='textSecondary'>
          {type === "sent" ? (
            <>
              You&#39;ve sent a friend request to <b>{name}</b>
            </>
          ) : (
            <>
              <b>{name}</b> sent you a friend request
            </>
          )}
          .
        </Typography>
      </Box>
      <Box display='flex' justifyContent='flex-end' mt={1}>
        <Button onClick={onCancel}>{type === "received" ? "Reject" : "Cancel"}</Button>
        {type === "received" && (
          <Button className={styles.acceptBtn} onClick={onAccept}>
            Accept
          </Button>
        )}
      </Box>
    </CardAsBox>
  );
}
